import { render, staticRenderFns } from "./GroundStationPeripheralControlPanel.vue?vue&type=template&id=24451bbf&scoped=true"
import script from "./GroundStationPeripheralControlPanel.vue?vue&type=script&lang=js"
export * from "./GroundStationPeripheralControlPanel.vue?vue&type=script&lang=js"
import style0 from "./GroundStationPeripheralControlPanel.vue?vue&type=style&index=0&id=24451bbf&prod&lang=scss&scoped=true"
import style1 from "./GroundStationPeripheralControlPanel.vue?vue&type=style&index=1&id=24451bbf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24451bbf",
  null
  
)

export default component.exports